import React from "react";
import Header from "../../components/common/Header";
import Sidebar from "../../components/common/Sidebar";
import Footer from "../../components/common/Footer";
import MemberList from "../../components/members/MemberList";
import { RODEO_PAGE_NAME } from "../../_config";

const MemberListContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.MEMBERS} showSettingsSidebar={true} />
      <MemberList />
      <Footer variant="dashboard" />
    </>
  );
};

export default MemberListContainer;
